export default __webpack_public_path__ + "static/media/Investmentimage.e6425040.svg";